/**
 * IMPORTS
 */

import { cn } from "@/data/lib/tailwind-merge";

type ISelectPaginationProps = {
  itemsPerPage: number;
  handleItemsPerPageChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  variant?: "default" | "compact";
  className?: string;
  selectId?: string;
};

const PAGE_SIZE_OPTIONS = {
  default: [10, 20, 30, 40, 50],
  compact: [6, 12, 18, 24],
} as const;

function SelectPagination({
  itemsPerPage,
  handleItemsPerPageChange,
  variant = "default",
  className,
  selectId = "itemsPerPage",
}: ISelectPaginationProps) {
  const options = PAGE_SIZE_OPTIONS[variant];

  return (
    <div className={cn("flex items-center", className)}>
      <label htmlFor={selectId} className="mr-2 text-sm text-gray-700">
        Itens por página:
      </label>
      <select
        id={selectId}
        value={itemsPerPage}
        onChange={handleItemsPerPageChange}
        className="rounded-md border border-gray-300 bg-white p-2 text-sm text-gray-700 shadow-sm focus-visible:border-blue-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
      >
        {options.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  );
}

/**
 * EXPORT
 */
export { SelectPagination };